import { ApiLoadingStatus } from "enum/api-loading-status.enum";
import type { ApiLoadingStatus as AuthLoadingStatus } from "interfaces/api.interface";

type LoadingStatus = ApiLoadingStatus | AuthLoadingStatus;

export const getAppLoadingState = ({
  isAdmin,
  authLoadingStatus,
  virtualWarehousesLoadingStatus,
  customersLoadingStatus,
  usersLoadingStatus,
  settingsLoadingStatus,
  bulkShipmentProfilesLoadingStatus,
}: {
  isAdmin: boolean;
  authLoadingStatus: AuthLoadingStatus;
  virtualWarehousesLoadingStatus: ApiLoadingStatus;
  customersLoadingStatus: ApiLoadingStatus;
  usersLoadingStatus: ApiLoadingStatus;
  settingsLoadingStatus: ApiLoadingStatus;
  bulkShipmentProfilesLoadingStatus: ApiLoadingStatus;
}) => {
  // Non-admins only wait on fetchMe (salesAccountUUID/userColumns) — the
  // shipments page doesn't need settings/bulk-profiles/warehouses to render,
  // so those load in parallel behind the UI instead of gating it. A failure
  // in any of them still surfaces the error screen.
  const requiredData: LoadingStatus[] = isAdmin
    ? [usersLoadingStatus, customersLoadingStatus]
    : [authLoadingStatus];

  const failureSources: LoadingStatus[] = isAdmin
    ? [usersLoadingStatus, customersLoadingStatus]
    : [
        authLoadingStatus,
        settingsLoadingStatus,
        bulkShipmentProfilesLoadingStatus,
        virtualWarehousesLoadingStatus,
      ];

  if (failureSources.some((status) => status === ApiLoadingStatus.FAILED))
    return ApiLoadingStatus.FAILED;

  return requiredData.every((status) => status === ApiLoadingStatus.SUCCESS)
    ? ApiLoadingStatus.SUCCESS
    : ApiLoadingStatus.LOADING;
};
